<template>
  <div>
    <div class="register-top">
      <h2 class="mb-6">{{ $t('register.identity.title') }}</h2>
      <h3>{{ user.firstname }} {{ user.lastname }}</h3>
      <h4>{{ user.profession }}</h4>
    </div>
    <div class="register-bottom">
      <register-base-button
        @click.native="showTutorial = true"
        gradient="linear-gradient(90deg, #7DCCAA 0%, #F1C63F 100%)"
      >
        {{ $t('register.identity.yes') }}
      </register-base-button>
      <br />
      <router-link :to="{ name: 'NotMe' }" class="register-link">
        {{ $t('register.identity.no') }}
      </router-link>
    </div>
    <tutorial-carousel v-if="showTutorial"></tutorial-carousel>
  </div>
</template>

<script>
import RegisterBaseButton from '@/components/RegisterBaseButton'
import TutorialCarousel from '@/components/TutorialCarousel'

export default {
  data() {
    return {
      showTutorial: false
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/get']
    }
  },
  components: {
    RegisterBaseButton,
    TutorialCarousel
  }
}
</script>
